import { useEffect, useMemo, useState } from 'react'
import { cssConstants } from '../constants'

export enum ScreenSize {
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}

function getWindowInnerWidth() {
  return window.innerWidth
}

export const useScreenSize = (): ScreenSize => {
  const [width, setWidth] = useState(getWindowInnerWidth())

  useEffect(() => {
    function handleResize() {
      setWidth(getWindowInnerWidth())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return useMemo(() => {
    if (width < cssConstants.tabletWidthBreakPoint) {
      return ScreenSize.mobile
    }

    if (width < cssConstants.desktopWidthBreakPoint) {
      return ScreenSize.tablet
    }

    return ScreenSize.desktop
  }, [width])
}

/**
 * Last resort because mui data grid does not accept vw
 */
export function useScreen() {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const [orientation, setOrientation] = useState(window.screen.orientation.type)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
      setOrientation(window.screen.orientation.type)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])
  return useMemo(
    () => ({
      width,
      height,
      orientation,
    }),
    [width, height, orientation],
  )
}
